export class StatisticMediaDto {
  statisticMediaId: number;
  categoryId: number;
  typeCategory: string;
  mediaId: number;
  action: string;
}
